export default __webpack_public_path__ + "static/media/smc-logo-typo-color-big.00f706a4.png";